"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("@angular/router");
const projects_component_1 = require("./projects.component");
const ɵ0 = () => Promise.resolve().then(() => require("./../map/index.ngfactory")).then(m => m.MapModuleNgFactory);
exports.ɵ0 = ɵ0;
const AppRoutes = [
    { path: '', component: projects_component_1.ProjectsListComponent, pathMatch: 'full' },
    { path: 'map', loadChildren: ɵ0 },
    { path: ':projId', component: projects_component_1.ProjectsListComponent, pathMatch: 'full' }
];
class DashboardModule {
}
exports.DashboardModule = DashboardModule;
